
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/au/thanks",
      function () {
        return require("private-next-pages/au/thanks.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/au/thanks"])
      });
    }
  